export default {
  width: 31,
  height: 24,
  svg: `
    <path fill-rule="evenodd" clip-rule="evenodd" d="M4 4h14a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6c0-1.1.9-2 2-2zm18 12.52V18a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V6a4 4 0 0 1 4-4h14a4 4 0 0 1 4 4v1.07l6.35-2.17A2 2 0 0 1 31 6.8v10.28a2 2 0 0 1-2.72 1.87L22 16.52zm0-7.34l7-2.39v10.3l-7-2.71v-5.2z"/>
  `
}
